module.exports = __webpack_public_path__ + "static/media/DQCompetencies_2023_Final.01fb82a8.png";